module.exports = __webpack_public_path__ + "static/img/gean.8df44b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/gean.png
// module id = d2dl
// module chunks = 1